
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  CreateReferralSubmissionRequest,
  CreateReferralSubmissionResponse,
  ReferralSubmissionForReferrerResponse,
} from '../models';
import {
    CreateReferralSubmissionRequestFromJSON,
    CreateReferralSubmissionRequestToJSON,
    CreateReferralSubmissionResponseFromJSON,
    CreateReferralSubmissionResponseToJSON,
    ReferralSubmissionForReferrerResponseFromJSON,
    ReferralSubmissionForReferrerResponseToJSON,
} from '../models';

export interface GetSubmissionsByReferrerRequest {
    referrerIdentityId: string;
}

export interface SubmitRequest {
    createReferralSubmissionRequest: CreateReferralSubmissionRequest;
}

/**
 * 
 */
export class SubmissionsApi extends runtime.BaseAPI {

    /**
     * Get current user referral submissions
          */
    async getCurrentSubmissionsRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<ReferralSubmissionForReferrerResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<ReferralSubmissionForReferrerResponse>>({
            path: `/business-referral/api/submission`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(ReferralSubmissionForReferrerResponseFromJSON);
        return response;
    }

    /**
     * Get current user referral submissions
          */
    async getCurrentSubmissions(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<ReferralSubmissionForReferrerResponse>> {
        const response = await this.getCurrentSubmissionsRaw(initOverrides);
        return response._data;
    }

    /**
     * Get referrer\'s submissions
          */
    async getSubmissionsByReferrerRaw(requestParameters: GetSubmissionsByReferrerRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<ReferralSubmissionForReferrerResponse>>> {
        if (requestParameters['referrerIdentityId'] == null) {
            throw new runtime.RequiredError(
                'referrerIdentityId',
                'Required parameter "referrerIdentityId" was null or undefined when calling getSubmissionsByReferrer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<ReferralSubmissionForReferrerResponse>>({
            path: `/business-referral/api/referrer/{referrerIdentityId}/submission`.replace(`{${"referrerIdentityId"}}`, encodeURIComponent(String(requestParameters['referrerIdentityId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(ReferralSubmissionForReferrerResponseFromJSON);
        return response;
    }

    /**
     * Get referrer\'s submissions
          */
    async getSubmissionsByReferrer(requestParameters: GetSubmissionsByReferrerRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<ReferralSubmissionForReferrerResponse>> {
        const response = await this.getSubmissionsByReferrerRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Creates a new referral
          */
    async submitRaw(requestParameters: SubmitRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<CreateReferralSubmissionResponse>> {
        if (requestParameters['createReferralSubmissionRequest'] == null) {
            throw new runtime.RequiredError(
                'createReferralSubmissionRequest',
                'Required parameter "createReferralSubmissionRequest" was null or undefined when calling submit().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<CreateReferralSubmissionResponse>({
            path: `/business-referral/api/submission`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateReferralSubmissionRequestToJSON(requestParameters['createReferralSubmissionRequest']),
        }, initOverrides);

        if (response._data) { response._data=CreateReferralSubmissionResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Creates a new referral
          */
    async submit(requestParameters: SubmitRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<CreateReferralSubmissionResponse> {
        const response = await this.submitRaw(requestParameters, initOverrides);
        return response._data;
    }

}
